import dayjs from "dayjs";
import { isEmpty } from "lodash";
const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

export const dateConverter = (date, time = null, combine = false) => {
  let dayJsDate = dayjs(date);

  if (combine && time !== null) {
    dayJsDate = dayJsDate
      .hour(dayjs(time).hour())
      .minute(dayjs(time).minute())
      .second(dayjs(time).second());
  }

  const convertedValue = combine
    ? dayJsDate.toISOString()
    : dayJsDate.format("YYYY-MM-DD");

  return {
    rawValue: dayJsDate,
    convertedValue: convertedValue,
  };
};

export const removeCodeFromNumber = (phn_number) => {
  const num_arr = phn_number.split("+91");
  if (num_arr?.length) {
    return num_arr[num_arr?.length - 1];
  }
  return phn_number;
};


export const formatTime = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const CustomTooltip = ({ active, payload }) => {
  if (active && !isEmpty(payload)) {
    const markupColor = `text-[${payload[0].payload.fill}]`;
    return (
      <div className=" backdrop-blur-3xl rounded-lg py-1 px-2 bg-white">
        <p
          className={`text-xs font-normal ${markupColor}`}
        >{`${payload[0].value} ${payload[0].name}`}</p>
      </div>
    );
  }
};

export const getNthdayDate = (n=7)=> {
  const today = new Date();
  const afterNDays = new Date(today);
  afterNDays.setDate(today.getDate() + n);
  return afterNDays
}